module.exports = __webpack_public_path__ + "img/mobile/SmartButton-auto/btn-stopp@1x.png?0.0.53";